/*
* Palo Alto Theme
* Custom JavaScript
*/

window.addEventListener("load", function () {
  requestAnimationFrame(function () {
    document.querySelectorAll(".product-grid-item").forEach(function (card) {
      const badgeWrapper = card.querySelector(".product-badge");
      const newBadge = card.querySelector(".grid-image-label");

      if (!newBadge) return;

      if (badgeWrapper) {
        card.classList.add("has-product-badge");
        newBadge.style.top = "44px";
      } else {
        card.classList.remove("has-product-badge");
        newBadge.style.top = "12px";
      }
    });
  });
});